import { Field, FormikProps, useFormikContext } from 'formik'
import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../../components/forms/FormSectionTwoColumns'
import RadioInput from '../../../../../../../../components/inputs/RadioInput'
import { RichTextInput } from '../../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { B3_FORM_INITIAL_VALUES } from '../constants'
import { CheckboxInput } from '../../../../../../../../components/inputs/CheckboxInput'
import { AccompanyingReportInputsPreview } from '../../../../../../../../components/AccompanyingReportInputsPreview'
import { FormLabel } from '../../../../../../../../components/FormLabel'

interface Props {}

export const B34BasicTechnicalDescription: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<typeof B3_FORM_INITIAL_VALUES>
  const newOrExistingLabel = formik.values?.readonly?.a1?.isNewConstruction
    ? 'novou stavbu.'
    : 'změnu stavby.'
  return (
    <FormSectionTwoColumns
      sectionKey="b3.basicTechnicalDescription"
      title="B.3.4 Základní technický popis stavby"
    >
      <div className="sm:col-span-6 p-5 rounded-md">
        <FormLabel>a) popis stávajícího stavu</FormLabel>
        <div className="mt-3">
          <AccompanyingReportInputsPreview>
            <div>Jedná se o {newOrExistingLabel}</div>
          </AccompanyingReportInputsPreview>
        </div>
        {!formik.values.readonly?.a1?.isNewConstruction && (
          <div className="">
            <div className="sm:col-span-6 mt-3">
              <Field
                name="b3.basicTechnicalDescription.a.description"
                label=""
                component={RichTextInput}
                aiHint={`Základní technický popis stavby - popis stávajícího stavu - jedná se o změnu stavby`}
              />
            </div>
          </div>
        )}
      </div>
      <div className="sm:col-span-6 flex flex-col gap-3">
        <label className="block text-sm font-semibold leading-6 pl-5 text-gray-900">
          b) popis navrženého stavebně technického a konstrukčního řešení
        </label>
        <div className="pl-5">
          <div className="sm:col-span-6 mt-5">
            <Field
              name={`b3.basicTechnicalDescription.b.constructionTechnicalSolution.enabled`}
              component={CheckboxInput}
              label="Stavebně technické řešení"
            />
            {formik.values.b3.basicTechnicalDescription.b.constructionTechnicalSolution.enabled && (
              <>
                <div className="pl-7">
                  <Field
                    name={`b3.basicTechnicalDescription.b.constructionTechnicalSolution.description`}
                    component={RichTextInput}
                    aiHint="Základní technický popis stavby - Stavebně technické řešení"
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className="pl-5">
          <div className="sm:col-span-6 mt-5">
            <Field
              name={`b3.basicTechnicalDescription.b.constructionSolution.enabled`}
              component={CheckboxInput}
              label="Konstrukční řešení"
            />
            {formik.values.b3.basicTechnicalDescription.b.constructionSolution.enabled && (
              <>
                <div className="pl-7">
                  <Field
                    name={`b3.basicTechnicalDescription.b.constructionSolution.description`}
                    component={RichTextInput}
                    aiHint="Základní technický popis stavby - Konstrukční řešení"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </FormSectionTwoColumns>
  )
}
